import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Zap, Shield, Clock, Target } from "lucide-react";

const benefits = [
  {
    icon: <Zap className="w-8 h-8 text-primary" />,
    title: "Fast Formation",
    description: "Get your business formed quickly with expedited filing options and streamlined processes."
  },
  {
    icon: <Shield className="w-8 h-8 text-primary" />,
    title: "Legal Protection",
    description: "Protect your personal assets with proper business entity formation and liability separation."
  },
  {
    icon: <Clock className="w-8 h-8 text-primary" />,
    title: "Save Time",
    description: "Focus on your business while we handle all the paperwork, filings, and legal requirements."
  },
  {
    icon: <Target className="w-8 h-8 text-primary" />,
    title: "Expert Guidance",
    description: "Get personalized advice on entity selection and structure to optimize for your business goals."
  }
];

const CompanyFormationBenefits = () => {
  return (
    <section className="py-16 px-4 bg-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Why Choose Our Formation Services?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Professional business formation services that set your company up for success from day one.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <Card key={index} className="text-center border hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="mx-auto mb-4">{benefit.icon}</div>
                <CardTitle className="text-xl">{benefit.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyFormationBenefits;